import type { Nullable } from 'corgi-types';

export const KEYWORD_DESCRIPTION_REGEX = /<<(.+?)>>\[(.+?)\](?!,"|,\\|})/g;

export const hasKeyword = (text: string) => KEYWORD_DESCRIPTION_REGEX.test(text);

const parseAbstract = (description: string): Nullable<string> => {
  try {
    return JSON.parse(description).abstract;
  } catch {
    return null;
  }
};

export const extractKeywordWithAbstract = (text: string) => {
  let match: Nullable<RegExpExecArray>;
  let keyword = null;
  let abstract = null;
  KEYWORD_DESCRIPTION_REGEX.lastIndex = 0;

  while ((match = KEYWORD_DESCRIPTION_REGEX.exec(text))) {
    keyword = match[1];
    abstract = parseAbstract(match[2]);
  }

  return { keyword, abstract };
};
